<template>
    <ul :id="`tree-node-actions-${nodo.id}`">
        <li>
          <a
            class="a-tooltip-primary a-tooltip-bottom"
            :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.editName')"
            href="#"
            @click.prevent="$modal.showModal('MoleculeEditionAssetContentsModalEditName'
              , {  'version': contenido, 'node': nodo })"
          >
            <i class="far fa-pencil-alt"></i>
          </a>
        </li>
        <li>
          <a
            class="a-tooltip-primary a-tooltip-bottom"
            :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.editContent')"
            href="#"
            @click.prevent="editNode"
          >
            <i class="far fa-file-alt"></i>
          </a>
        </li>
        <li v-if="level < 2">
          <a
            class="a-tooltip-primary a-tooltip-bottom"
            :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.createSubContent')"
            href="#"
            @click.prevent="$modal.showModal('MoleculeEditionAssetContentsModalCreateSubContent'
              , { 'version': contenido, 'padre': nodo.id })"
          >
            <i class="far fa-plus"></i>
          </a>
        </li>
        <li>
          <a
            class="a-tooltip-primary a-tooltip-bottom delete-content-action"
            :data-tooltip-text="$t('mEditionAssetContentsTreeNodeActions.actions.deleteContent')"
            href="#"
            @click.prevent="$modal.showModal('MoleculeEditionAssetContentsModalDeleteContent'
              , nodo)"
          >
            <i class="far fa-trash-alt"></i>
          </a>
        </li>
    </ul>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentsTreeNodeOperations',

  props: {
    contenido: {
      type: Object,
      default: null
    },

    nodo: {
      type: Object,
      default: null
    },

    level: {
      type: Number,
      default: 0
    }
  },

  computed: {
    nodeLength () {
      return this.nodo.children ? this.nodo.children.length : 0
    }
  },

  methods: {
    editNode () {
      this.$store.commit('setAssetSelectedNode', this.nodo)
    }
  }
}
</script>
